module.exports = __webpack_public_path__ + "static/media/bio-thumb.1d6b4065.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bio-thumb.png
// module id = 265
// module chunks = 0